<template>
  <div class="number-info-body">
    <gov-info ref="gov" v-if="type === 1" @success="handleSuccess" />
    <enp-info ref="enp" v-else @success="handleSuccess" />
    <div class="number-info-footer">
      <a-button @click="nextStep">下一步</a-button>
      <p><span @click="previous">&lt; 上一步</span></p>
    </div>
  </div>
</template>

<script>
import GovInfo from "@/page/registered/modules/GovInfo";
import EnpInfo from "@/page/registered/modules/EnpInfo";

export default {
  components: { EnpInfo, GovInfo },
  props: ["type"],
  data() {
    return {};
  },
  watch: {},
  mounted() {},
  methods: {
    handleSuccess(data) {
      this.$emit("next", data);
    },
    // 下一步
    nextStep() {
      if (this.type === 1) {
        this.$refs.gov.submit();
      } else {
        this.$refs.enp.submit();
      }
    },
    // 上一步
    previous() {
      this.$emit("pre");
    },
  },
};
</script>

<style lang="less" scoped>
.number-info-body {
  height: 100%;
  width: 640px;
  margin: 0 auto;
  padding: 40px 0;

  .number-info-footer {
    > button {
      display: block;
      width: 100%;
      height: 48px;
      background: #1abc9c;
      border-color: #1abc9c;
      border-radius: 2px;
      font-size: 16px;
      color: #fff;
      margin-bottom: 24px;
    }

    > p {
      display: flex;
      align-items: center;
      justify-content: center;

      > span {
        color: #1abc9c;
        cursor: pointer;
      }
    }
  }
}
</style>
<style>
.write-info-content .ant-input {
  flex: 1;
}
</style>
